import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { DeviationVehicle } from '@/types/deviation-vehicle'

export function createDeviationVehicle(
  body: Partial<DeviationVehicle>
): Promise<AxiosResponse<DeviationVehicle>> {
  return instance.post(`/deviation-vehicle`, body)
}
